import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const REVENUE_OPTIONS = [
  "Less than R50,000/month",
  "R50,000 - R150,000/month",
  "R150,000 - R500,000/month",
  "R500,000 - R1,000,000/month",
  "R1,000,000+/month",
  "Prefer not to say",
];

export const ContactBusinessStep = ({ formData, onChange }) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Contact & Business Profile</h2>
      <p className="text-gray-500 text-sm">Tell us about you and your business.</p>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Full Name *</label>
        <Input value={formData.contact_name} onChange={(e) => onChange("contact_name", e.target.value)} placeholder="John Smith" className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-contact-name" required />
      </div>
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Email Address *</label>
        <Input type="email" value={formData.contact_email} onChange={(e) => onChange("contact_email", e.target.value)} placeholder="john@company.com" className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-contact-email" required />
      </div>
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Phone Number</label>
        <Input value={formData.contact_phone} onChange={(e) => onChange("contact_phone", e.target.value)} placeholder="+27 66 123 4567" className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-contact-phone" />
      </div>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Business Name *</label>
        <Input value={formData.business_name} onChange={(e) => onChange("business_name", e.target.value)} placeholder="e.g. Acme Corp" className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-business-name" required />
      </div>
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Website URL</label>
        <Input value={formData.website_url} onChange={(e) => onChange("website_url", e.target.value)} placeholder="https://www.yourcompany.com" className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-website-url" />
      </div>
    </div>

    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Industry *</label>
        <Input value={formData.industry} onChange={(e) => onChange("industry", e.target.value)} placeholder="e.g. E-commerce, Finance, SaaS" className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-industry" required />
      </div>
      <div>
        <label className="block text-sm text-gray-300 mb-1.5">Revenue Range *</label>
        <Select value={formData.revenue_range} onValueChange={(v) => onChange("revenue_range", v)}>
          <SelectTrigger className="bg-white/5 border-white/10 text-white" data-testid="select-revenue-range"><SelectValue placeholder="Select range" /></SelectTrigger>
          <SelectContent>{REVENUE_OPTIONS.map((opt) => (<SelectItem key={opt} value={opt}>{opt}</SelectItem>))}</SelectContent>
        </Select>
      </div>
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">Briefly describe your products or services *</label>
      <Textarea value={formData.business_description} onChange={(e) => onChange("business_description", e.target.value)} placeholder="What does your business offer? Who do you serve?" rows={3} className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-business-description" required />
    </div>

    <div>
      <label className="block text-sm text-gray-300 mb-1.5">Who is your target audience?</label>
      <Textarea value={formData.target_audience} onChange={(e) => onChange("target_audience", e.target.value)} placeholder="Demographics, interests, pain points..." rows={2} className="bg-white/5 border-white/10 text-white placeholder:text-gray-600" data-testid="input-target-audience" />
    </div>
  </div>
);
